export { ShareComponent } from './share-component'
export { ShareWrapper } from './share-wrapper'
